import type { Filter, FilterOption } from '~/types/Catalog';
import type { LocationQuery, LocationQueryRaw } from 'vue-router';

type CatalogQuery = LocationQuery | LocationQueryRaw;

export interface CatalogFastPropertyFilter {
  slug: string;
  title: string;
  options: FilterOption[];
}

export function getCatalogFastPropertyFilter(filters: Filter[]): CatalogFastPropertyFilter | null {
  const filter = filters.find(
    (candidate) =>
      candidate.slug !== 'categories' &&
      candidate.type === 'checkbox' &&
      candidate.options?.some((option) => typeof option.fast_filter === 'number'),
  );

  if (!filter) return null;

  return {
    slug: filter.slug,
    title: filter.title,
    options: [...filter.options]
      .filter((option) => typeof option.fast_filter === 'number')
      .sort((a, b) => (a.fast_filter ?? 0) - (b.fast_filter ?? 0)),
  };
}

export function selectCatalogFastFilterQuery(
  query: CatalogQuery,
  filterSlug: string,
  value: string | number,
): LocationQueryRaw {
  const key = `filter[${filterSlug}]`;
  const nextQuery: LocationQueryRaw = {
    ...query,
    [key]: String(value),
  };

  delete nextQuery.page;

  return nextQuery;
}

export function isCatalogFastFilterActive(query: CatalogQuery, filterSlug: string, value: string | number): boolean {
  const rawValue = query[`filter[${filterSlug}]`];
  const serializedValue = Array.isArray(rawValue) ? rawValue[0] : rawValue;

  return typeof serializedValue === 'string' && serializedValue.split(';').includes(String(value));
}

export function getVisibleCatalogFastFilterOptions(
  filter: CatalogFastPropertyFilter,
  query: CatalogQuery,
): FilterOption[] {
  return filter.options.filter((option) => !isCatalogFastFilterActive(query, filter.slug, option.value));
}
